import { MessageSquare, Sparkles, Globe, Shield } from "lucide-react";
import { useTranslation } from 'react-i18next';

export function DashboardHeader() {
  const { t } = useTranslation('business', { keyPrefix: 'communication' });
  
  return (
    <div className="relative">
      <div className="flex items-start justify-between">
        <div className="space-y-4">
          <div className="flex items-center gap-3">
            <div className="relative">
              <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-emerald-500 to-emerald-600 flex items-center justify-center shadow-lg shadow-emerald-500/25">
                <MessageSquare className="w-6 h-6 text-white" />
              </div>
              <div className="absolute -top-1 -right-1 w-5 h-5 rounded-full bg-gradient-to-r from-emerald-500 to-purple-500 flex items-center justify-center shadow-md">
                <Sparkles className="w-2.5 h-2.5 text-white" />
              </div>
            </div>
            <div>
              <h1 className="text-3xl font-bold tracking-tight bg-gradient-to-r from-slate-900 via-slate-800 to-slate-700 bg-clip-text text-transparent">
                {t('aiChatbotConfiguration')}
              </h1>
              <p className="text-slate-600 mt-1 leading-relaxed">
                {t('configureAIPoweredAssistant')}
              </p>
            </div>
          </div>
          
          {/* Quick Stats with Enhanced Contrast */}
          <div className="flex items-center gap-4 pt-2">
            <div className="flex items-center gap-2 px-3 py-1.5 rounded-full bg-emerald-50 border border-emerald-200/80 shadow-sm">
              <div className="w-2 h-2 rounded-full bg-emerald-500" />
              <span className="text-sm font-medium text-emerald-700">{t('aiReady')}</span>
            </div>
            <div className="flex items-center gap-2 px-3 py-1.5 rounded-full bg-blue-50 border border-blue-200/80 shadow-sm">
              <Globe className="w-3.5 h-3.5 text-blue-600" />
              <span className="text-sm font-medium text-blue-700">{t('webIntegration')}</span>
            </div>
            <div className="flex items-center gap-2 px-3 py-1.5 rounded-full bg-purple-50 border border-purple-200/80 shadow-sm">
              <Shield className="w-3.5 h-3.5 text-purple-600" />
              <span className="text-sm font-medium text-purple-700">{t('secure')}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}